import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '~/store';

const currentClanIdSelector = (state: RootState) => state.currentAccount?.clanId || null;

const clansItemsSelector = (state: RootState) => state.clans.items;

export const currentClanSelector = createSelector(
  [currentClanIdSelector, clansItemsSelector],
  (currentClanId, clanItems) => {
    return currentClanId ? clanItems[currentClanId] || null : null;
  },
);
